import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Inject,
  Input,
  OnInit,
  Output
} from '@angular/core';

import { FileValidator } from 'ngx-material-file-input';
// import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';

import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Tecnico } from '../../../entity-tecnicos/entity-tecnicos.model';
import { TecnicoResponsable } from '../../entity-tecnico-responsable.model';

@Component({
  selector: 'rpe-tecnico-responsable-acreditacion-form',
  templateUrl: './tecnico-responsable-acreditacion-form.component.html',
  styleUrls: ['./tecnico-responsable-acreditacion-form.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class TecnicoResponsableAcreditacionFormComponent implements OnInit {
  tRDAFormGroup: FormGroup;
  tecnicoResponsable: TecnicoResponsable;

  readonly maxSize = 10485760; // 10MB

  @Input()
  set formInput(tecnicoResponsable: TecnicoResponsable) {
    if (tecnicoResponsable != null) {
      this._formInput = tecnicoResponsable;
      const auxTecnico: Tecnico = {
        ...tecnicoResponsable.tecnico,
        acreditado: 1
      };
      this.tecnicoResponsable = { ...tecnicoResponsable, tecnico: auxTecnico };
    }
  }

  get formInput(): TecnicoResponsable {
    return this._formInput;
  }

  _formInput: TecnicoResponsable;

  @Output() formStatusChanges = new EventEmitter<string>();
  @Output() formValueChanges = new EventEmitter<TecnicoResponsable>();

  constructor(
    private fb: FormBuilder,
    public dialogRef: MatDialogRef<TecnicoResponsableAcreditacionFormComponent>,
    @Inject(MAT_DIALOG_DATA) public data: TecnicoResponsable
  ) {}

  ngOnInit() {
    this.tRDAFormGroup = this.fb.group({
      cv: [
        null,
        [Validators.required, FileValidator.maxContentSize(this.maxSize)]
      ],
      carta_recomendacion: [null, [FileValidator.maxContentSize(this.maxSize)]]
    });

    // emit events
    this.tRDAFormGroup.valueChanges.subscribe((_) => {
      this.formValueChanges.emit({
        ...this.tecnicoResponsable,
        ...this.tRDAFormGroup.value
      });
    });
    this.tRDAFormGroup.statusChanges.subscribe((f) => {
      this.formStatusChanges.emit(f);
    });
  }

  validateFileExtension(fileName: string) {
    return (
      fileName.endsWith('.jpg') ||
      fileName.endsWith('.pdf') ||
      fileName.endsWith('.rar') ||
      fileName.endsWith('.7z') ||
      fileName.endsWith('.zip')
    );
  }

  onFileChange(field: string) {
    if (this.tRDAFormGroup.get(field).value) {
      if (
        this.validateFileExtension(
          this.tRDAFormGroup.get(field).value._fileNames
        )
      ) {
      } else {
        this.tRDAFormGroup.controls[field].setErrors({
          incorrect: true
        });
      }
    }

    // call the emit values and status
    this.tRDAFormGroup.updateValueAndValidity({
      onlySelf: false,
      emitEvent: true
    });
  }
}
